var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:none;stroke:#FFFFFF;stroke-width:0.1;stroke-miterlimit:10;}\n\t.st1{fill:#54C1B7;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 50,
    height: 50
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,43.3c-1.2,0-2.4-0.4-3.4-1.3L4.2,31.3c-1-0.9-1.7-2.2-1.8-3.5c-0.1-1.4,0.3-2.7,1.2-3.8l3.1-3.6 c1-1.1,2.4-1.8,3.9-1.8c1.2,0,2.4,0.4,3.4,1.3l5.3,4.6L35.3,8.3c1-1,2.3-1.6,3.7-1.6c1.4,0,2.6,0.5,3.6,1.5l3.4,3.3 c2,2,2.1,5.3,0.1,7.3l-22.4,23C22.7,42.7,21.4,43.3,20,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39,7.7c1.1,0,2.1,0.4,2.9,1.2l3.4,3.3c1.6,1.6,1.7,4.3,0.1,5.9L23,41c-0.8,0.8-1.9,1.3-3,1.3 c-1,0-2-0.4-2.7-1L4.9,30.6c-0.8-0.7-1.4-1.7-1.4-2.9c-0.1-1.1,0.3-2.2,1-3l3.1-3.6c0.8-0.9,1.9-1.4,3.2-1.4c1,0,2,0.4,2.7,1 l5.3,4.6c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3L36,9C36.8,8.2,37.9,7.7,39,7.7 M39,5.7c-1.7,0-3.2,0.7-4.4,1.9 L19.4,23.2l-4.6-4c-1.1-1-2.6-1.5-4-1.5c-1.8,0-3.5,0.8-4.7,2.1L3,23.4c-1.1,1.2-1.6,2.8-1.5,4.5c0.1,1.6,0.9,3.1,2.1,4.2 L16,42.8c1.1,1,2.6,1.5,4,1.5c1.7,0,3.2-0.7,4.4-1.9l22.4-23c2.4-2.4,2.3-6.4-0.1-8.7l-3.4-3.3C42.1,6.3,40.6,5.7,39,5.7 L39,5.7z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconTick);
export default __webpack_public_path__ + "static/media/cloud_icon_tick.f15365af7d11ab6d89d838787b237ecc.svg";
export { ForwardRef as ReactComponent };